export type Role = 'admin' | 'member';
// GPU NeevCloud and RackBank are temporarily disabled — re-enable by widening
// this union and adding the matching entries in lib/products.ts
// (PRODUCT_THEME) and server/src/domain/enums.ts (PRODUCTS/PRODUCT_LABELS).
export type Product = 'cpu_neevcloud' | 'pulse_neevcloud';
export type Category =
  | 'ui_bug'
  | 'customer_feedback'
  | 'feature_request'
  | 'performance_issue'
  | 'other';
export type Status = 'new' | 'in_progress' | 'resolved';
export type Visibility = 'public' | 'private';

export type User = {
  id: string;
  name: string;
  email: string;
  role: Role;
  avatar: string | null;
  title: string | null;
};

export type Suggestion = {
  id: string;
  product: Product;
  category: Category;
  title: string;
  description: string;
  imageUrl: string | null;
  priority: number;
  visibility: Visibility;
  status: Status;
  resolutionNote: string | null;
  resolvedAt: string | null;
  submittedBy: User;
  assignedTo: User | null;
  createdAt: string;
  updatedAt: string;
  _count?: { comments: number };
};

export type Comment = {
  id: string;
  body: string;
  createdAt: string;
  author: User;
};

export type Activity = {
  id: string;
  action: string;
  note: string | null;
  meta: Record<string, unknown> | null;
  createdAt: string;
  actor: User;
};

export type SuggestionDetail = Suggestion & {
  comments: Comment[];
  activity: Activity[];
};

export type Permissions = {
  canEdit: boolean;
  canManage: boolean;
  canAssign: boolean;
  canDelete: boolean;
};

export type Stats = {
  total: number;
  assignedToMe: number;
  highPriority: number;
  byStatus: Partial<Record<Status, number>>;
  byProduct: Partial<Record<Product, number>>;
};

export type Paginated<T> = {
  items: T[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
};

export type ListFilters = {
  product: Product[];
  category: Category[];
  status: Status[];
  visibility: Visibility | '';
  assignedToId: string;
  scope: 'all' | 'assigned_to_me' | 'submitted_by_me';
  q: string;
  minPriority: number;
  sort: 'newest' | 'oldest' | 'priority' | 'status';
  page: number;
};

export const EMPTY_FILTERS: ListFilters = {
  product: [],
  category: [],
  status: [],
  visibility: '',
  assignedToId: '',
  scope: 'all',
  q: '',
  minPriority: 0,
  sort: 'newest',
  page: 1,
};
